<template>
    <div class="row">
        <header-servico
            tipo="Medidas Socioeducativas"
            :loading="loading"
            :familia="familia.id"
        />
        <load
            v-if="loading"
            message="Carregando as Medidas Socioeducativas da Família"
        />
        <div v-else class="col-md-12">
            <!--Tabela-->
            <div class="row">
                <sidebar-servicos active="medidas" />
                <div class="col-md-9">
                    <div class="row">
                        <div class="col-md-12">
                            <header-familia :item="familia" />
                        </div>
                    </div>
                    <div class="card mb-0 shadow">
                        <div class="card-body">
                            <div class="row" v-if="adolescentes.length <= 0">
                                <div class="col-12">
                                    <div
                                        class="alert alert-info bg-gradient-info"
                                    >
                                        O grupo familiar não tem na sua
                                        composição adolescente com idade para
                                        cumprimento de medida socioeducativa.
                                    </div>
                                </div>
                            </div>
                            <div v-else class="tab-content">
                                <div
                                    v-if="!novo_medida"
                                    class="animate__animated animate__fadeIn"
                                >
                                    <div class="row">
                                        <div class="col-12">
                                            <div
                                                class="d-flex align-items-center justify-content-between mb-4"
                                            >
                                                <div>
                                                    <button
                                                        class="btn btn-primary"
                                                        @click="
                                                            novo_medida = true
                                                        "
                                                    >
                                                        <i
                                                            class="fas fa-plus-square"
                                                        />
                                                        {{ $t("Cadastrar") }}
                                                    </button>
                                                </div>
                                                <div>
                                                    <b-button-group>
                                                        <b-button
                                                            variant="outline-dark"
                                                            :class="
                                                                viewFilterReport ===
                                                                true
                                                                    ? 'active'
                                                                    : ''
                                                            "
                                                            @click="viewFilters"
                                                        >
                                                            <i
                                                                class="fas fa-filter"
                                                            ></i>
                                                            {{ $t("Filtros") }}
                                                        </b-button>
                                                        <b-button
                                                            variant="outline-dark"
                                                            @click="print()"
                                                        >
                                                            <i
                                                                class="fas fa-print"
                                                            ></i>
                                                        </b-button>
                                                    </b-button-group>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div
                                            class="col-12"
                                            v-if="viewFilterReport"
                                        >
                                            <form
                                                @submit.prevent="getMedidas"
                                                ref="formFiltros"
                                            >
                                                <div class="row">
                                                    <form-calendar
                                                        v-model="data_inicio"
                                                        grid="4"
                                                        label="Data Inicial"
                                                    />
                                                    <form-calendar
                                                        v-model="data_fim"
                                                        grid="4"
                                                        label="Data Final"
                                                        :required="
                                                            verificaDataInicial
                                                        "
                                                    />
                                                    <form-select
                                                        v-model="filtroStatus"
                                                        grid="4"
                                                        label="Status"
                                                        :itens="status"
                                                        :loading="loadingStatus"
                                                        :disabled="
                                                            loadingStatus
                                                        "
                                                        multiple
                                                    />
                                                    <form-select
                                                        v-model="filtroFamiliar"
                                                        label="Pesquisar Familiar"
                                                        :itens="familiares"
                                                        grid="12"
                                                    />
                                                </div>
                                                <div
                                                    class="row pt-2 mb-4 px-0 d-flex justify-content-end"
                                                >
                                                    <div
                                                        class="col-auto px-2 text-right"
                                                    >
                                                        <button
                                                            class="btn btn-default btn-sm"
                                                            @click.prevent="
                                                                limparFiltros();
                                                                viewFilterReport = false;
                                                            "
                                                        >
                                                            <i
                                                                class="fas fa-times"
                                                            ></i>
                                                        </button>
                                                        <button
                                                            type="button"
                                                            class="btn btn-secondary btn-sm"
                                                            @click.prevent="
                                                                limparFiltros()
                                                            "
                                                        >
                                                            {{
                                                                $t(
                                                                    "Limpar Filtros"
                                                                )
                                                            }}
                                                        </button>
                                                        <button
                                                            class="btn btn-success btn-submit btn-sm"
                                                            data-style="zoom-in"
                                                            type="submit"
                                                        >
                                                            <i
                                                                class="fas fa-chart-bar"
                                                            ></i>
                                                            {{ $t("Filtrar") }}
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                        <load
                                            mode="table"
                                            v-if="loadingMedidas"
                                        />
                                        <div class="col-12" v-else>
                                            <span>
                                                <a v-if="!showName" @click.prevent="mostrarNome" href="#"><i class="fas fa-eye"></i> Mostrar Nome de Registro</a> 
                                                <a v-else @click.prevent="ocultarNome" href="#"><i class="fas fa-eye-slash"></i> Ocultar Nome de Registro</a> 
                                            </span>
                                            <print-content>
                                                <b-table
                                                    :fields="[
                                                        {
                                                            key: 'protocolo',
                                                            label: $t(
                                                                'Detalhes'
                                                            ),
                                                        },
                                                        {
                                                            key: 'usuario_idade',
                                                            key: 'usuario_idade',
                                                            label: $t('Idade'),
                                                        },
                                                        {
                                                            key: 'cadastrado',
                                                            label: $t(
                                                                'Cadastro'
                                                            ),
                                                        },
                                                        {
                                                            key: 'status_nome',
                                                            label: $t('Status'),
                                                        },
                                                        {
                                                            key: 'actions',
                                                            label: '',
                                                            class: 'text-right no-print',
                                                            thStyle: {
                                                                width: '95px',
                                                                minWidth:
                                                                    '95px',
                                                            },
                                                        },
                                                    ]"
                                                    :items="medidasList"
                                                    :responsive="true"
                                                    striped
                                                    hover
                                                    show-empty
                                                    small
                                                    outlined
                                                    stacked="xs"
                                                    table-class="mb-3"
                                                >
                                                    <template
                                                        v-slot:cell(protocolo)="data"
                                                    >
                                                        Usuário: 
                                                        <b v-if="!data.item.usuario_nome_social" >
                                                            {{data.item.usuario_nome}}
                                                        </b>
                                                        <b v-else>
                                                            {{ data.item.usuario_nome_social }} ( N.R.: ) <span v-if="showName">{{ data.item.usuario_nome }}</span>
                                                        </b>
                                                        <br />
                                                        Tipo:
                                                        <b>{{
                                                            data.item.tipo
                                                        }}</b>
                                                        <br />
                                                        Processo:
                                                        <b>{{
                                                            !!data.item
                                                                .numero_processo ? data.item.numero_processo : 'N/A'
                                                        }}</b>
                                                        <br />
                                                        Protocolo:
                                                        <b>{{
                                                            data.item.protocolo
                                                        }}</b>
                                                        <br/>
                                                        Técnico autor:
                                                        <b>{{ data.item.autor }}</b>
                                                        <br/>
                                                        <span class="d-block">
                                                            <i
                                                                class="mdi mdi-lock mdi-18px text-danger"
                                                                v-if="
                                                                    data.item
                                                                        .privado ==
                                                                    1
                                                                "
                                                                v-b-popover.hover.top="
                                                                    'Medida sigilosa'
                                                                "
                                                            ></i>
                                                        </span>
                                                    </template>
                                                    <template
                                                        v-slot:cell(usuario_idade)="data"
                                                    >
                                                        <b
                                                            >{{
                                                                data.item
                                                                    .usuario_idade
                                                            }}
                                                            anos</b
                                                        >
                                                    </template>
                                                    <template
                                                        v-slot:cell(cadastrado)="data"
                                                    >
                                                        {{
                                                            data.item.cadastrado
                                                        }}
                                                    </template>
                                                    <template
                                                        v-slot:cell(status_nome)="data"
                                                    >
                                                        <span
                                                            class="small"
                                                            v-html="
                                                                data.item
                                                                    .status_nome
                                                            "
                                                        ></span>
                                                    </template>
                                                    <template
                                                        v-slot:cell()="data"
                                                    >
                                                        <button 
                                                            v-if="data.item.is_owner"
                                                            @click="
                                                                redirectMedida(
                                                                    data.item.id
                                                                )
                                                            "
                                                            class="px-2 mb-0 btn btn-sm btn-success"
                                                        >
                                                            <i
                                                                class="mdi mdi-square-edit-outline"
                                                            />
                                                        </button>
                                                        <button
                                                            v-else-if="(unidade_id == data.item.unidade_id) && ($store.state.user.role_details.name == 'Coordenador' || $store.state.user.role_details.name == 'Gestor(a)' || $store.state.user.role_details.name == 'Técnico(a) de Nível Superior')"
                                                            @click="showMedida(data.item.id)"
                                                            class="px-2 mb-0 btn btn-sm btn-primary"
                                                        >
                                                            <i class="mdi mdi-eye" />
                                                        </button>
                                                    </template>
                                                    <template
                                                        v-slot:empty="scope"
                                                    >
                                                        <div
                                                            class="text-center my-5"
                                                        >
                                                            <img
                                                                :alt="
                                                                    $t(
                                                                        'No results'
                                                                    )
                                                                "
                                                                class="mb-5"
                                                                src="/img/icons/robot.svg"
                                                                style="
                                                                    max-height: 165px;
                                                                "
                                                            />
                                                            <h3 class="bold">
                                                                {{
                                                                    $t(
                                                                        "No records found"
                                                                    )
                                                                }}
                                                            </h3>
                                                        </div>
                                                    </template>
                                                </b-table>
                                            </print-content>
                                            <div
                                                class="row align-items-center no-print"
                                            >
                                                <div class="col-lg-6 col-md-12">
                                                    <div
                                                        class="form-group d-inline-flex mb-0"
                                                    >
                                                        <select
                                                            class="form-control"
                                                            style="width: 70px"
                                                            v-model="perPage"
                                                            v-on:change="
                                                                getMedidas
                                                            "
                                                        >
                                                            <option value="5">
                                                                5
                                                            </option>
                                                            <option value="10">
                                                                10
                                                            </option>
                                                            <option value="25">
                                                                25
                                                            </option>
                                                            <option value="50">
                                                                50
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <div
                                                        class="d-inline-flex ml-2"
                                                    >
                                                        <b-pagination
                                                            :per-page="perPage"
                                                            :total-rows="
                                                                pagination.total
                                                            "
                                                            @change="changePage"
                                                            v-model="page"
                                                        />
                                                    </div>
                                                </div>
                                                <div
                                                    class="col-lg-6 col-md-12 mt-4 mt-lg-0"
                                                >
                                                    <div class="float-lg-right">
                                                        {{ $t("Showing page") }}
                                                        {{
                                                            pagination.currentPage
                                                        }}
                                                        {{ $t("of") }}
                                                        {{
                                                            pagination.totalPages
                                                        }}
                                                        {{ $t("pages in") }}
                                                        {{ pagination.total }}
                                                        {{ $t("records") }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <NovoMedida
                                    v-else
                                    :familia="familia"
                                    @voltar="novo_medida = false"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import NovoMedida from "./Add";
export default {
    components: { NovoMedida },
    name: "MedidasSocioeducativas",
    metaInfo() {
        return {
            title: this.$i18n.t("Medidas Socioeducativas"),
        };
    },
    data() {
        return {
            showName: false,
            familia: {},
            novo_medida: false,
            TipomedidasList: [],
            medidasList: [],
            page: 1,
            search: "",
            perPage: 10,
            loadingMedidas: true,
            loading: true,
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0,
            },
            loadingStatus: false,
            filtroStatus: [],
            filtroDatas: [],
            status: [],
            filtroFamiliar: null,
            familiares: [],
            adolescentes: [],
            unidade_id: null,
        };
    },
    mounted() {
        this.getAdolescentes();
        this.$route.query.familia_id = this.$route.params.id;
        if (typeof this.$route.query.item === "object") {
            this.familia = this.$route.query.item;
        } else {
            this.getFamilia();
        }
    },
    methods: {
        mostrarNome() {
            this.showName = true;
        },
        ocultarNome() {
            this.showName = false;
        },
        getAdolescentes() {
            axios
                .get(
                    `api/dashboard/medidas/adolescentes/get/${this.$route.params.id}`
                )
                .then((response) => {
                    this.adolescentes = response.data;
                })
                .finally(() => {
                    this.loading = false;
                    if (this.adolescentes.length > 0) {
                        this.getMedidas();
                        this.getStatus();
                    }
                });
        },
        getMedidas() {
            this.loadingMedidas = true;
            this.filtroDatas = [];
            if (this.data_inicio) {
                this.filtroDatas = this.filtroDatas.concat(
                    this.$options.filters.formatDateYMD(this.data_inicio)
                );
            }
            if (this.data_fim) {
                this.filtroDatas = this.filtroDatas.concat(
                    this.$options.filters.formatDateYMD(this.data_fim)
                );
            }
            axios
                .get("api/dashboard/medidas", {
                    params: {
                        id: this.$route.params.id,
                        page: this.page,
                        search: this.search,
                        perPage: this.perPage,
                        filtroStatus: this.filtroStatus,
                        filtroDatas: this.filtroDatas,
                        filtroFamiliar: this.filtroFamiliar,
                    },
                })
                .then((response) => {
                    this.medidasList = response.data.data;
                    this.pagination = response.data.pagination;
                    this.unidade_id = this.$store.state.user.tecnico.unidade_id;
                    if (
                        this.pagination.totalPages < this.pagination.currentPage
                    ) {
                        this.page = this.pagination.totalPages;
                        this.getMedidas();
                    } else {
                        this.loadingMedidas = false;
                    }
                })
                .catch(() => {
                    this.loadingMedidas = false;
                });
        },
        changePage(page) {
            if (
                page > 0 &&
                page <= this.pagination.totalPages &&
                page !== this.page
            ) {
                this.page = page;
                this.getMedidas();
            }
        },
        redirectMedida(id) {
            this.$router.push({
                path: `/dashboard/medida/edit/${id}`,
                query: { familia_id: this.$route.query.familia_id },
            });
        },
        showMedida(id) {
            this.$router.push({
                path: `/dashboard/medida/show/${id}`,
            });
        },
        getFamilia() {
            axios
                .get("api/dashboard/familias/" + this.$route.params.id)
                .then((response) => {
                    this.familia = response.data.data;
                    this.familiares = this.familia.familiares.map((elem) => ({
                        id: elem.id,
                        value: elem.nome_completo,
                    }));
                    this.$route.query.familia_id = this.familia.id;
                    this.loading = false;
                })
                .catch(() => {
                    this.$router.push("/dashboard/familias");
                });
        },
        getStatus() {
            this.loadingStatus = true;
            axios
                .get(`api/dashboard/report/status/medidas`)
                .then((response) => {
                    this.status = response.data;
                })
                .finally(() => {
                    this.loadingStatus = false;
                });
        },
        limparFiltros() {
            this.search = "";
            this.filtroStatus = null;
            this.filtroDatas = [];
            this.data_inicio = "";
            this.data_fim = "";
            this.getAtendimentos();
        },
    },
};
</script>
